export const ATTN_DATA_ATTR = 'data-is-attentive-popup-disabled';
